



























































import { Component, Vue } from "vue-property-decorator";
import {
  Notificacao,
  TipoEnvioNotificacao,
  PublicoEnvioNotificacao,
  CentralNotificacoesService,
} from "@/services/central-notificacao.service";
import Modal from "@/shared/components/modal.vue";
import { dateTime } from "@/shared/filters";
import { Catalogo, CatalogosService } from "@/services/catalogos.service";
@Component({
  components: { Modal },
  filters: { dateTime },
})
export default class VisualizarNotificacao extends Vue {
  notificacao: Notificacao | null = null;
  loading = false;
  somenteAtivosCheckbox = false;
  enviarPara: TipoEnvioNotificacao | null = null;
  publicoEnvio: PublicoEnvioNotificacao | null = null;
  listaCatalogos: Catalogo[] = [];
  idsCatalogos: string[] = [];

  publicoEnvioItems = [
    { text: "Todos", value: null },
    { text: "Grátis", value: PublicoEnvioNotificacao.Gratis },
    { text: "Lite", value: PublicoEnvioNotificacao.Lite },
    { text: "Essencial", value: PublicoEnvioNotificacao.Essencial },
    { text: "Essencial Conectada", value: PublicoEnvioNotificacao.EssencialConectada },
    { text: "Super Conectada", value: PublicoEnvioNotificacao.SuperConectada },
    { text: "Hiper Conectada", value: PublicoEnvioNotificacao.HiperConectada },
  ];

  get catalogosItems() {
    const fixos = [
      { text: "Todos", value: "todos"}
    ];

    const dinamicos = this.listaCatalogos.map(c => ({
      text: c.nome,
      value: c.idCatalogo
    }));

    return [...fixos, ...dinamicos];
  }

  onCatalogosChange(val: string[]){
    if(val.includes("todos")) {
      this.idsCatalogos = this.listaCatalogos.map(c => c.idCatalogo);
    }
  }

  async enviarNotificacao() {
    if (this.notificacao) {
      if (this.enviarPara !== TipoEnvioNotificacao.Nenhum) {
        this.loading = true;
        this.enviarPara = this.somenteAtivosCheckbox ? TipoEnvioNotificacao.Ativos : TipoEnvioNotificacao.Todos;
        CentralNotificacoesService.enviarNotificacao(
          this.notificacao.idNotificacao,
          this.enviarPara,
          this.publicoEnvio,
          this.idsCatalogos
        );
        this.loading = false;
      }
    }
    const modal = this.$refs.modal as Modal;
    return modal.close(true);
  }

  public async visualizarNotificacao(id: string) {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();

    this.loading = true;
    this.notificacao = await CentralNotificacoesService.obterNotificacao(id);
    this.listaCatalogos = await CatalogosService.listarCatalogosGlobais();
    this.loading = false;

    return p;
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  get tipoEnvio(): typeof TipoEnvioNotificacao {
    return TipoEnvioNotificacao;
  }

  montarConteudoIframe(html: string) {
    if (!html) return '';
    
    return `
      <html>
        <head>
          <base target="_blank">
          <style>
            html, body { 
              margin: 0; 
              padding: 0; 
              font-family: sans-serif; 
              font-size: 14px; 
              overflow: hidden;
            }
          </style>
        </head>
        <body class="ck-content">
          ${html}
        </body>
      </html>
    `;
  }

  ajustarAltura(event: any) {
    const iframe = event.target;
    const atualizar = () => {
      if (iframe.contentWindow && iframe.contentWindow.document.body) {
        iframe.style.height = (iframe.contentWindow.document.body.scrollHeight + 10) + 'px';
      }
    };
    
    atualizar();
    setTimeout(atualizar, 300);
  }
}
